import { useState, useEffect } from "react";

import {Collection} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import { S3Provider } from "./../providers/S3Provider"
import { FolderCard } from "../components/FolderCard";

import { Grid } from 'react-loader-spinner'

import './HomePage.css'


function HomePage() {
  const [folders, setFolders] = useState<string[]>([])
  
  const fetchFolders = async () => {
    setFolders((await S3Provider.listFolders()).map(e => e.substring(0, e.length - 1)))
  }
  
  useEffect(() => {
    fetchFolders()
  }, [])

  return (
    <>
      <h1>LSCOBA Event Gallery</h1>
      {folders.length === 0 ?
        <Grid
          height="50"
          width="50"
          ariaLabel="grid-loading"
          radius="12.5"
          wrapperStyle={{ margin: '20px auto' }}
          wrapperClass=""
          visible={true}
          color='#772ddb'
        />
        :
      <Collection
        items={folders}
        type="list"
        padding="2rem"
        boxShadow="0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
        gap="small"
      >
        {(item, index) => (
          <FolderCard
            key={index}
            folder={item}
          />
        )}
      </Collection>
      }
      <div className="tiled-gallery__gallery">
        <div className="tiled-gallery__row">
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '36.37880%' }}
          >
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/LSC-Aerial-photo-1963-1024x616.jpg" />
            <DecorImg src="https://i0.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/staff-photo-1946-47-1024x683.jpg" />
          </div>
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '31.05744%' }}
          >
            <DecorImg src="https://i0.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/LSC-75th-anniversary-blazar-badge-683x1024.jpg" />
          </div>
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '32.56376%' }}
          >
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/10343.jpg" />
            <DecorImg src="https://i0.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/10347.jpg" />
          </div>
        </div>
        <div className="tiled-gallery__row">
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '36.00467%' }}
          >
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/10251.jpg" />
          </div>
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '63.99533%' }}
          >
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/8366-1024x381.jpg" />
          </div>
        </div>
        <div className="tiled-gallery__row">
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '62.27547%' }}
          >
            <DecorImg src="https://i1.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/9694.jpg" />
          </div>
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '37.72453%' }}
          >
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/5426-1024x768.jpg" />
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/8327-1024x654.jpg" />
          </div>
        </div>
        <div className="tiled-gallery__row">
        <div
            className="tiled-gallery__col"
            style={{ flexBasis: '41.76259%' }}
          >
            <DecorImg src="https://i1.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/2433.jpg" />
            <DecorImg src="https://i0.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/445-1024x717.jpg" />
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/113.jpg" />
          </div>
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '58.23741%' }}
          >
            <DecorImg src="https://i1.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/199.jpg" />
          </div>
        </div>
        <div className="tiled-gallery__row">
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '58.75760%' }}
          >
            <DecorImg src="https://i0.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/250.jpg" />
          </div>
          <div
            className="tiled-gallery__col"
            style={{ flexBasis: '41.24240%' }}
          >
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/265.jpg" />
            <DecorImg src="https://i2.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/264.jpg" />
            <DecorImg src="https://i1.wp.com/www3.lscoba.com/wp-content/uploads/ImageAlbum/000-start-20220106-temp/146.jpg" />
          </div>
        </div>
        <em>If you are the photographer behind the photo(s) and want to be credited, please contact us.</em>
      </div>
    </>
  );
}
export default HomePage;

function DecorImg({ src }: { src: string }) {
  return (
    <figure className="tiled-gallery__item">
      <a href={src}>
        <img className="tiled-gallery__img" src={src} />
      </a>
    </figure>
  );
}